export const decodeHtmlEntities = (str: string | null) => {
  if (str === null || str === undefined) return "";
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, "text/html");
  return decodeURIComponent(doc.documentElement.textContent as string);
};
